module.exports = __webpack_public_path__ + "facelifting_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_3_before.jpg
// module id = 1054
// module chunks = 0